/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Usage_Metric_CharactersInputs */

const en_usage_metric_characters = /** @type {(inputs: Usage_Metric_CharactersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Characters`)
};

const fr_usage_metric_characters = /** @type {(inputs: Usage_Metric_CharactersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Personnages`)
};

const de_usage_metric_characters = /** @type {(inputs: Usage_Metric_CharactersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Charaktere`)
};

const it_usage_metric_characters = /** @type {(inputs: Usage_Metric_CharactersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Caratteri`)
};

const ru_usage_metric_characters = /** @type {(inputs: Usage_Metric_CharactersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Персонажи`)
};

const es_usage_metric_characters = /** @type {(inputs: Usage_Metric_CharactersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Personajes`)
};

const zh_cn2_usage_metric_characters = /** @type {(inputs: Usage_Metric_CharactersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`人物`)
};

const ja_usage_metric_characters = /** @type {(inputs: Usage_Metric_CharactersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`キャラクター`)
};

const hi_usage_metric_characters = /** @type {(inputs: Usage_Metric_CharactersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`पात्रों`)
};

const pt_pt2_usage_metric_characters = /** @type {(inputs: Usage_Metric_CharactersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Personagens`)
};

/**
* | output |
* | --- |
* | "Characters" |
*
* @param {Usage_Metric_CharactersInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const usage_metric_characters = /** @type {((inputs?: Usage_Metric_CharactersInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Usage_Metric_CharactersInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_usage_metric_characters(inputs)
	if (locale === "de") return de_usage_metric_characters(inputs)
	if (locale === "it") return it_usage_metric_characters(inputs)
	if (locale === "ru") return ru_usage_metric_characters(inputs)
	if (locale === "es") return es_usage_metric_characters(inputs)
	if (locale === "zh-CN") return zh_cn2_usage_metric_characters(inputs)
	if (locale === "ja") return ja_usage_metric_characters(inputs)
	if (locale === "hi") return hi_usage_metric_characters(inputs)
	if (locale === "pt-PT") return pt_pt2_usage_metric_characters(inputs)
	return en_usage_metric_characters(inputs)
});